import { render, staticRenderFns } from "./admin-overview.vue?vue&type=template&id=63ce0c55&scoped=true&"
import script from "./admin-overview.vue?vue&type=script&lang=js&"
export * from "./admin-overview.vue?vue&type=script&lang=js&"
import style0 from "./admin-overview.vue?vue&type=style&index=0&id=63ce0c55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ce0c55",
  null
  
)

export default component.exports